import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { IonIcon } from '@ionic/angular/standalone';
import { Store } from "@ngrx/store";
import { Environment, ENVIRONMENT } from "@qid/env";
import { SexyModule } from '@qid/sexy';
import { Subject, takeUntil } from "rxjs";
import { ScannersFacade } from "../../+state/scanners.facade";
import { AuthSelectors } from "../../../authentication";
import { TemplateQrViewComponent } from '../template-qr-view/template-qr-view.component';

@Component({
    selector: 'template-slider',
    templateUrl: './template-slider.component.html',
    styleUrls: ['./template-slider.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        IonIcon,
        SexyModule,
        TemplateQrViewComponent
    ]
})
export class TemplateSliderComponent implements OnInit {

    @Input() baseUrl: string = this.environment.collectUrl;

    @Output() onTemplateCreate: EventEmitter<any> = new EventEmitter()

    public scanners$ = this.scannerFacade.allRecords$

    loading = false;

    public pageClosed$ = new Subject();

    constructor(
        private router: Router,
        private store: Store,
        private scannerFacade: ScannersFacade,
        @Inject(ENVIRONMENT) private environment: Environment
    ) {
    }

    ngOnInit() {
        this.store.select(AuthSelectors.selectActiveAccount)
            .pipe(takeUntil(this.pageClosed$))
            .subscribe(() => {
                this.scannerFacade.init()
            })
    }

    ngOnDestroy() {
        this.pageClosed$.next(null);
        this.pageClosed$.complete()
    }


    routeToScanner() {
        this.router.navigateByUrl('menu/scanners');
    }


}
